import gsap from 'gsap';
import scrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(scrollTrigger)

window.addEventListener('frame-ready', init)

function init() {
    let header = document.querySelector('.header-mobile--main')

    window.addEventListener('scroll', () => {

        if(header.offsetHeight <= window.scrollY) {
            document.body.classList.add('sticky')
        } else {
            document.body.classList.remove('sticky')
        }
    })

}
